import { JsonFormat, stringJsonFormat } from "@redotech/json/format";

export enum TriggerType {
  ORDER_CREATED = "order_created",
  PRE_TRANSIT = "pre_transit",
  IN_TRANSIT = "in_transit",
  OUT_FOR_DELIVERY = "out_for_delivery",
  DELIVERED = "delivered",
  PICKUP = "available_for_pickup",
  // Problem statuses
  STALLED = "stalled_in_transit",
  DELAYED = "delayed",
  ARRIVING_EARLY = "arriving_early",
  RETURN_TO_SENDER = "return_to_sender",
  DELIVERY_ATTEMPTED = "delivery_attempted",
  FAILURE = "failure",
  CANCELLED = "cancelled",
  ERROR = "error",
}

export const triggerTypeJsonFormat: JsonFormat<TriggerType> = <
  JsonFormat<TriggerType>
>stringJsonFormat;
